import { defaultConfig, getApi, getContentRoutes, getFooterLinks, getHeaderLinks } from '../../base/defaultConfig';

export const config = {
  ...defaultConfig,
  'global.brandName': 'Mail Holidays',
  'global.textHighlight': 'secondary',
  'google.gtm': 'GTM-T762HDC',
  'socialMedia.telephone': 'tel:03332201937',
  'user.optin.emailOpt': true,
  'user.optin.smsOpt': true,
  'user.optin.thirdOpt': true,
  'logo.width': '188px',
  siteCode: 'MT',
};

export const contentRoutes = [
  ...getContentRoutes(config),
  { path: '/privacy-policy', url: 'age/1904' },
  { path: '/customer-charter', url: 'age/1603' },
  { path: '/offers', url: 'age/1526' },
  { path: '/about-us', url: 'age/1516' },
  { path: '/cottages', url: 'age/662' },
  { path: '/european-holiday-parks', url: 'age/1597' },
  { path: '/holiday-home-sales', url: 'age/1386' },
  { path: '/hotels', url: 'age/664' },
];

const footerData = getFooterLinks(config);
const remove = ['hotels', 'cheapercaravan'];
const filteredLinks = footerData.findAHoliday1.links.filter((link) => !remove.includes(link.id));
export const footerLinks = {
  ...footerData,
  findAHoliday1: {
    ...footerData.findAHoliday1,
    links: filteredLinks,
  },
};

export const urls = getApi(config, 'api');

export const HeaderLinks = getHeaderLinks([1, 4, 6]);
